module.exports = __webpack_public_path__ + "img/header-weddingRingsCrown@2x.7f262fd.webp";